import React from 'react';
import Icon from '../../../components/AppIcon';


const ApprovalStatisticsCard = ({ title, value, icon: Icon, color }) => {
  const getColorClasses = (color) => {
    const colors = {
      amber: 'bg-amber-50 border-amber-200 text-amber-700',
      emerald: 'bg-emerald-50 border-emerald-200 text-emerald-700',
      red: 'bg-red-50 border-red-200 text-red-700',
      blue: 'bg-blue-50 border-blue-200 text-blue-700'
    };
    return colors?.[color] || 'bg-gray-50 border-gray-200 text-gray-700';
  };

  const getIconColorClasses = (color) => {
    const colors = {
      amber: 'text-amber-600',
      emerald: 'text-emerald-600',
      red: 'text-red-600',
      blue: 'text-blue-600'
    };
    return colors?.[color] || 'text-gray-600';
  };

  return (
    <div className={`rounded-lg border p-6 ${getColorClasses(color)}`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium opacity-80">{title}</p>
          <p className="text-3xl font-bold mt-2">{value}</p>
        </div>
        <div className={`w-12 h-12 rounded-lg bg-white flex items-center justify-center ${getIconColorClasses(color)}`}>
          <Icon className="w-6 h-6" />
        </div>
      </div>
    </div>
  );
};

export default ApprovalStatisticsCard;